// Cookie/consent management (152-ФЗ).
// No analytics or monitoring tracker may run until the visitor has explicitly
// accepted. Yandex.Metrika and Sentry are loaded lazily only after consent.
import * as Sentry from '@sentry/react';
import {SENTRY_DSN} from '../config/env';

const CONSENT_KEY = 'cookie_consent_v1';

const DOMAIN_COUNTER_MAP = {
    'selebrus.ru': 106567758,
    'xn--90ahax1abfp.xn--p1ai': 108170525,       // селебрус.рф
};

function getCounterId() {
    return DOMAIN_COUNTER_MAP[window.location.hostname] || 106567758;
}

export function getConsent() {
    try {
        return localStorage.getItem(CONSENT_KEY);
    } catch {
        return null;
    }
}

export function setConsent(value) {
    try {
        localStorage.setItem(CONSENT_KEY, value);
    } catch {
        /* storage unavailable — treat as no persisted consent */
    }
}

export function hasAnalyticsConsent() {
    return getConsent() === 'accepted';
}

let metrikaLoaded = false;

function loadYandexMetrika() {
    if (metrikaLoaded || typeof window === 'undefined') return;
    metrikaLoaded = true;
    const cid = getCounterId();
    (function (m, e, t, r, i, k, a) {
        m[i] = m[i] || function () {
            (m[i].a = m[i].a || []).push(arguments);
        };
        m[i].l = 1 * new Date();
        k = e.createElement(t);
        a = e.getElementsByTagName(t)[0];
        k.async = 1;
        k.src = r;
        a.parentNode.insertBefore(k, a);
    })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js?id=' + cid, 'ym');

    window.ym(cid, 'init', {
        ssr: true,
        webvisor: true,
        clickmap: true,
        ecommerce: 'dataLayer',
        accurateTrackBounce: true,
        trackLinks: true,
    });

    window.__ymCounterId = cid;
}

let sentryLoaded = false;

function initSentry() {
    if (sentryLoaded || !import.meta.env.PROD) return;
    sentryLoaded = true;
    Sentry.init({
        dsn: SENTRY_DSN,
    });
}

// Turn on all opt-in analytics/monitoring. Call only after explicit consent.
export function enableAnalytics() {
    loadYandexMetrika();
    initSentry();
}

// On app start: re-enable tracking if the visitor accepted in a previous visit.
export function initConsentedAnalytics() {
    if (hasAnalyticsConsent()) {
        enableAnalytics();
    }
}
